import { IntlShape } from 'react-intl';

import { FACET } from '@app/components';
import { sharedMessages } from '@app/translations';

import { FacetInstanceDto } from '../constants';

export const getInitialFacets = ($t: IntlShape['$t']): FacetInstanceDto => {
  return {
    [FACET.STATUS]: {
      label: $t({
        id: 'facets.status',
        defaultMessage: 'Status',
      }),
      values: null,
    },
    [FACET.FORMAT]: {
      label: $t(sharedMessages.format),
      values: null,
    },
    [FACET.LOCATION]: {
      label: $t(sharedMessages.location),
      values: null,
    },
    [FACET.PUBLISHER]: {
      label: $t(sharedMessages.publisher),
      values: null,
    },
    [FACET.LANGUAGE]: {
      label: $t(sharedMessages.language),
      values: null,
    },
    [FACET.SUBJECT]: {
      label: $t(sharedMessages.subject),
      values: null,
    },
  };
};
